const baseColors = {
  primary: '#1B30F5',
  secondary: '#3e4685',
  active: '',
  hover: '',
  error: '#FC0167',
  warning: '#FF8888',
  info: '#6284C6',
  success: '#28B59B',
}

const palette = {
  text: {
    documentSectionFieldTitle: '#6D76AA',
    primary: baseColors.secondary,
    white: '#FFFFFF',
    navBar: '#FFFFFF',
    darkBlue: baseColors.primary,
    blue: baseColors.secondary,
    transparentGray: '#7D81A8',
    darkMain: '#505B67',
    lightGray: '#828282',
    secondGray: '#8E92CA',
    labelGray: '#A5ADCA',
    red: '#FF6258',
    secondaryRed: '#FF0068',
    conflictRed: '#FC0167',
    greenCheck: '#28B59B',
    green: '#29B137',
    greenSecond: '#28AD9F',
    greenSuccess: '#37B9A3',
    blueLabel: '#6284C6',
    hoverBlue: baseColors.primary,
    black: '#000000',
    blueLabelDisabled: '#C1D3F8',
    gold: '#ffc107',
    info: baseColors.primary,
    blueEmpty: '#6284C6',
  },
  bg: {
    white: '#FFFFFF',
    whiteTransparent: 'rgba(255, 255, 255, 0.9)',
    blueLabelDisabled: '#F4F9FD',
    transparentWhite: '#F7F9FC',
    noActiveWhite: '#F2F7FB',
    closedBg: '#ECECEE',
    canceledBg: '#F4E8EC',
    documentSectionGray: '#F7FAFC',
    dividerLine: '#EAF1F8',
    gray: '#ECF0F5',
    greyLight: '#F1F6FB',
    grayDisabled: '#DDE6F4',
    grayBadge: '#F0F5FA',
    pink: '#DF9EB5',
    navBar: '#000C68',
    blue: '#3e4685',
    darkPrimary: '#0300A9',
    blueSecond: '#1B30F5',
    toxicBlue: '#1C31F5',
    blueEmpty: '#E4ECF6',
    toastBlue: '#64D2FF',
    blueLabel: '#6284C6',
    toastGreen: '#00C868',
    hover: '#77D6B0',
    secondGray: '#AEBACF',
    conflictRed: '#FC0167',
    toastError: '#FF2D55',
    burgundyRed: '#DE035C',
    grayMedium: '#CCD2E3',
    grayBlur: '#D2E0FA',
    transparentBlueLabel: '#ffffff80',
    black: '#000000',
    modalBg: '#0B0E2C',
    scrollBar: '#3e4685',
    lightGray: '#C1D3F8',
    warningBg: '#FFB661',
    green: '#28B59B',
    red: '#FF0000',
    periwinkle: '#CEDCFF',
    purple: '#9A7DED',
    teal: '#69E8C9',
  },
  status: {
    green: '#3DBDAE',
    mintGreen: '#96DCBA',
    azure: '#63C7F1',
    blue: '#5489ED',
    purple: '#C5A6F6',
    pink: '#F67AA6',
    orange: '#F49090',
    gray: '#97ACCA',
    lightGreen: '#D8F4F1',
    lightMintGreen: '#D5F6E6',
    lightAzure: '#E1F2F9',
    lightPurple: '#EBE2FA',
    lightPink: '#FFDDE9',
    lightOrange: '#F8E1E1',
    lightGray: '#DBE4F1',
    primaryBlue: baseColors.primary,
    red: '#FF0068',
  },
  icon: {
    white: '#FFFFFF',
    navBar: '#6284C6',
    navBarLink: '#FFFFFF',
    primary: baseColors.secondary,
    arrowBlue: '#6284C6',
    secondBlue: '#6A98F2',
    blueLabelDisabled: '#C1D3F8',
    blue: baseColors.primary,
    purple: '#8E92CA',
    red: '#FF0068',
    warning: baseColors.warning,
    conflictRed: '#FC0167',
    greenSecond: '#28AD9F',
    original: '#28AF9D',
    greenCheck: '#28B59B',
    gray: '#323232',
    green: '#4EC970',
    greenSuccess: '#37B9A3',
    grayOff: '#D9D9D9',
  },
  border: {
    documentSectionBorder: '#ECF3F9',
    conflictRed: '#FC0167',
    focus: baseColors.primary,
    active: baseColors.primary,
    valid: '#29B137',
    invalid: '#FF6258',
    white: '#ffffff',
    blue: baseColors.secondary,
    green: '#4EC970',
    secondBlue: baseColors.primary,
    input: '#CCD2E3',
    darkGray: '#AAB4BD',
    dividerLine: '#EAF1F8',
    lightGray: '#C1D3F8',
    blueStroke: '#010168',
    blueLabel: '#6284C6',
    blueDash: '#D2E0FA',
    blueEmptyDash: '#B7D0F0',
    checkbox: '#DEE7EF',
    greenCheck: '#28B59B',
    crayola: '#BFCDE7',
    aliceBlue: '#FEF5EC',
    greyDividerLine: '#E4EDF6',
  },
  contentLoader: {
    base: baseColors.primary,
    highlight: baseColors.secondary,
  },
  gradient: {
    tabButton: 'linear-gradient(180deg, #fff 0%, #FFFFFF00 50%)',
  },
  shadow: {
    primary: 'rgba(0, 23, 233, 0.1)',
    secondary: 'rgba(0, 23, 233, 0.05)',
  },
  btn: {
    primary: {
      bg: baseColors.secondary,
      bgHover: '#FFFFFF',
      text: '#FFFFFF',
      textDisabled: '#C1D3F8',
    },
    secondary: {
      bg: '#FFFFFF',
      bgDisabled: '#F4F9FD',
      text: baseColors.secondary,
      textDisabled: '#C1D3F8',
      border: '#EAF1F8',
      borderHover: baseColors.secondary,
    },
    success: {
      text: '#FFFFFF',
      bg: baseColors.success,
    },
    inCircle: {
      bg: '#FFFFFF',
      border: '#EAF1F8',
    },
    iconButton: {
      bg: 'transparent',
      border: 'none',
    },
    dashedBlue: {
      border: '#B7D0F0',
      bg: '#e4ecf6',
    },
    default: {
      bgDisabled: '#ECF0F5',
      textDisabled: '#FFFFFF',
      border: 'transparent',
    },
  },
  ...baseColors,
}

export default palette
